import { atomWithStorage } from 'jotai/utils';

/** Staff-only (isInternalUser) three.js FPS overlay in the 3D viewer; per browser, off by default. */
export const showFpsAtom = atomWithStorage<boolean>('gis.viewer.showFps', false);
